/**
 * 评论填写组件
 * @created on 2017/9/18
 * @author laixinyu <laixinyualex@gmail.com>
 **/
import './index.css'

import { setHeader } from 'cm'

let placeholderDom = `<div class="textearDiv">
<p>每次真诚的回应，都是爱与勇气的传递。</br></br>· 精华回答，会获得打赏和推荐；</br>· 建议您多换行和分段，排版更好看；</br>· 凝练小标题，更易阅读和理解。</p>
</div>`

export default class Comment {
  constructor(
    option = {
      el: 'body'
    }
  ) {
    // let ua = window.navigator.userAgent

    this.$el = document.querySelector(option.el)
    this.stateObj = { comment: 'comment' }
    /*    this.winHeight = window.innerHeight;

        this.device = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ? 'IOS' : 'ANDROID';

        // 兼容ios下虚拟键盘弹出后遮挡头部问题
        window.addEventListener('resize', e => {
          let _winHeight = window.innerHeight;

          if (this.device === 'IOS' && this.winHeight != _winHeight) {
            let top;

            if (this.styleTop && this.styleTop != 0) {
              top = 0;
            } else {
              top = this.winHeight - _winHeight;
            }

            this.styleTop = top;

            if (this.$root) {
              let $globalHeader = this.$root.querySelector('.global-header');

              setTimeout(() => {
                $globalHeader.style.marginTop = $globalHeader.getBoundingClientRect().top + 'px';
              }, 0);
            }
          }
        }); */
  }

  // 显示评论组件
  show(
    option = {
      title: '回复',
      placeholder:
        '一个感同身受的回应，有效的解决问题的方法，都是对提问者有用的回答',
      callback(content) {
        console.log(content)
      },
      max: null
    }
  ) {
    if (!this.$root) {
      this.render(option.title, option.placeholder)
    }
    if (option.title !== this.$title) {
      this.$title = option.title
      this.setTitle(option.backFn, this.$title, option.skipApp)
    }

    // 最大字数限制
    if (option.max) {
      this.__MAX = option.max
    }

    this.$callback = option.callback

    let doc = document.documentElement
    /**
     * modify by htd
     * time: 2019-02-28
     * describe：注释body定位为fixed，开启回复插件隐藏container，关闭回复插件则显示container，解决IOS滑动卡住现象
     */
    // doc.style.position = 'fixed';

    doc.style.top = '0'
    doc.style.bottom = '0'
    doc.style.height = '100%'
    doc.style.overflow = 'hidden'

    this.$root.style.display = 'block'
    this.$content.focus()

    $('.container').hide()
    // 用于回复评论草稿辨识
    this.type = option.type || null

    if (
      this.type === 'answer' &&
      window.localStorage.getItem('answer_content')
    ) {
      this.$content.value = window.localStorage.getItem('answer_content')

      setTimeout(() => {
        if (
          !window.$platform.isYixinliApp &&
          !localStorage.has_answerContent_Interaction
        ) {
          window.toast('在app发布，可以累积积分，免费换书', 5000)
          localStorage.has_answerContent_Interaction = true
        }
      })
    } else if (
      this.type !== 'answer' &&
      window.localStorage.getItem('reply_content')
    ) {
      this.$content.value = window.localStorage.getItem('reply_content')
    }
    let self = this
    $('.comment-body').on('input', function() {
      if (self.type === 'answer') {
        if ($('.comment-body').val() !== '') {
          $('.textearDiv').hide()
        } else {
          $('.textearDiv').show()
        }
        window.localStorage.setItem('answer_content', $('.comment-body').val())
      } else {
        window.localStorage.setItem('reply_content', $('.comment-body').val())
      }
      $('.comment-body').css('height', 'auto')
      $('.comment-body').css('height', $('.comment-body')[0].scrollHeight + 2)
    })

    if ($('.textearDiv').length === 0) {
      $('.comment-wrap').append(placeholderDom)
    }
    if (this.$content.value.trim() !== '') {
      $('.textearDiv').hide()
    } else {
      if (this.type === 'answer') {
        $('.textearDiv').show()
      }
    }

    // 兼容ios下面遮挡问题；
    setTimeout(() => {
      document.documentElement.scrollTop = document.body.scrollTop = 0
    }, 0)
    /* window.history.pushState(this.stateObj, 'comment', 'comment'); */
  }

  render(title, placeholder) {
    let template = `
      <div class="comment-wrap">
          <textarea class="comment-body" placeholder="${placeholder}"></textarea>
      </div>`

    this.$root = document.createElement('div')
    this.$root.className = 'comment-container'
    this.$root.innerHTML = template

    this.$content = this.$root.querySelector('.comment-body')
    this.setTitle(title)

    this.$el.appendChild(this.$root)
  }

  // setTitle
  setTitle(backFn, title, skipApp) {
    const self = this
    const $config = {
      el: this.$root,
      title: title,
      button: [
        {
          icon: 'back',
          position: 'left',
          callback() {
            if (self.type === 'answer') {
              window.localStorage.setItem('answer_content', self.$content.value)
            } else {
              window.localStorage.setItem('reply_content', self.$content.value)
            }

            self.hide('EXIT')
            if (backFn) {
              backFn()
            }
            /* window.history.back(); */
          }
        },
        {
          customHTML: '完成',
          class: 'comment-close',
          position: 'right',
          callback() {
            self.hide('FINISH')
          }
        }
      ],
      mode: 'before',
      skipApp
    }
    if (skipApp) {
      $config.skipApp = true
    }
    setHeader($config)
  }

  // 隐藏评论组件
  hide(type) {
    console.log('hide')
    $('.comment-body').off('input')
    let doc = document.documentElement

    /* window.history.replaceState(this.stateObj, 'comment', 'comment'); */
    doc.style.position = ''
    doc.style.top = ''
    doc.style.bottom = ''
    doc.style.height = ''
    doc.style.overflow = ''

    this.$root.style.display = 'none'

    /**
     * modify by htd
     * time: 2019-02-28
     * describe：解决IOS滑动卡住现象
     */
    $('.container').show()

    if (type === 'FINISH') {
      let _comment = this.getContent()
      if (this.__MAX && _comment.length > this.__MAX) {
        let tips = `不能超过${this.__MAX}个字！`
        if (window.toast) {
          window.toast(tips)
        } else {
          alert(tips)
        }
        return
      }
      typeof this.$callback === 'function' && this.$callback(_comment)
    }

    this.$content.value = ''
  }

  // 获取内容
  getContent() {
    console.log('getContent')

    return this.$content.value
  }
}



// WEBPACK FOOTER //
// ./src/public-resource/components/Commnet/index.js